import Link from '@material-ui/core/Link';
import Email from '@pe-libs/react-components/build/components/PeIcons/Email.svg';
import Facebook from '@pe-libs/react-components/build/components/PeIcons/Facebook.svg';
import LinkedIn from '@pe-libs/react-components/build/components/PeIcons/LinkedIn.svg';
import Twitter from '@pe-libs/react-components/build/components/PeIcons/Twitter.svg';
import WhatsApp from '@pe-libs/react-components/build/components/PeIcons/WhatsApp.svg';
import Xing from '@pe-libs/react-components/build/components/PeIcons/Xing.svg';
import PeLink from '@pe-libs/react-components/build/components/PeLink';
import PeTypography from '@pe-libs/react-components/build/components/PeTypography';
import useEventTracker from '@pe-libs/react-components/build/lib/hooks/useEventTracker';
import useIntlMessage from '@pe-libs/react-components/build/lib/intl/hooks/useIntlMessage';
import { useRouter } from 'next/router';
import React from 'react';
import { useSelector } from 'react-redux';
import { getProfilePublicData } from '#modules/defaultLandingReferral/selectors';
import messages from './messages';
import useStyles from './styles';

type Props = { link: string };

const Socials: React.FC<Props> = ({ link }) => {
  const styles = useStyles();
  const formatMessage = useIntlMessage();
  const { dispatchEvent } = useEventTracker();
  const router = useRouter();
  const { id: reviewId, email: emailAddress } = router.query;

  const data = useSelector(getProfilePublicData);

  const profileName = data.attributes.title;
  const profileId = data.attributes.id;

  const encodedLink = encodeURIComponent(link);

  const socialText = encodeURIComponent(`${formatMessage(messages.emailContent, { profileName })} ${link}`);
  const twitterText = encodeURIComponent(`${formatMessage(messages.emailContent, { profileName })}`);

  const openSocialProfile = (itmMedium: string) => {
    dispatchEvent({
      from: 'referral-feature',
      type: 'referral-feature.cta.clicked',
      payload: {
        profileId,
        reviewId,
        emailAddress,
      },
      metrics: {
        itmMedium,
      },
    });

    return false;
  };

  return (
    <>
      <PeTypography variant="body1">{formatMessage(messages.socials)}</PeTypography>
      <div className={styles.socialButtonContainer}>
        <Link
          target="_blank"
          href={`mailto:?subject=${formatMessage(messages.emailSubject, { profileName })}
            &body=${socialText}`}
          onClick={() => openSocialProfile('referral-feature-mailto-button')}
        >
          <Email />
        </Link>
        <PeLink
          href={`https://api.whatsapp.com/send?text=${socialText}`}
          target="_blank"
          onClick={() => openSocialProfile('referral-feature-whatsapp-button')}
        >
          <WhatsApp />
        </PeLink>
        <PeLink
          href={`https://www.facebook.com/sharer.php?u=${encodedLink}&quote=${socialText}`}
          target="_blank"
          onClick={() => openSocialProfile('referral-feature-facebook-button')}
        >
          <Facebook />
        </PeLink>
        <PeLink
          href={`https://twitter.com/intent/tweet?url=${encodedLink}&text=${twitterText}`}
          target="_blank"
          onClick={() => openSocialProfile('referral-feature-twitter-button')}
        >
          <Twitter />
        </PeLink>
        <PeLink
          href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodedLink}`}
          target="_blank"
          onClick={() => openSocialProfile('referral-feature-linked-button')}
        >
          <LinkedIn />
        </PeLink>
        <PeLink
          href={`https://www.xing.com/spi/shares/new?url=${encodedLink}`}
          target="_blank"
          onClick={() => openSocialProfile('referral-feature-xing-button')}
        >
          <Xing />
        </PeLink>
      </div>
    </>
  );
};

export default Socials;
